import axios from "axios";

export default {
    getVacationDuration: async (companyId, personId, timezone, countryCode, dateFrom, dateUntil, calendarType) => {
        const { data } = await axios.get(`/calendar/vacation_duration`, { params: {
            company_id: companyId,
            person_id: personId,
            timezone: timezone,
            country_code: countryCode,
            date_from: dateFrom,
            date_until: dateUntil,
            calendar_type: calendarType
        }})

        return data
    },
}